var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"title":"学者库"},on:{"filtrate":_vm.filtrate}}),(!_vm.isHot)?_c('Contentslist'):_vm._e(),(_vm.isHot)?_c('Filtrate',{on:{"closeTheScreen":_vm.closeTheScreen}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }